import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _classPrivateFieldLooseBase from '@babel/runtime/helpers/esm/classPrivateFieldLooseBase';
import _classPrivateFieldLooseKey from '@babel/runtime/helpers/esm/classPrivateFieldLooseKey';
import React__default, { createElement, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

var MSG_TYPE = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};
var POSITION = {
  TOP_CENTER: 'top-center',
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_CENTER: 'bottom-center',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left'
};
var DEFAULTS = {
  position: POSITION.TOP_RIGHT,
  autoDismiss: true,
  timeOut: 5000,
  single: false,
  icons: true,
  pauseOnHover: true,
  showProgress: false
};

function generateUID() {
  var first = (Math.random() * 46656).toString(36).slice(-3);
  var second = Date.now().toString(36);
  return first + "-" + second;
}
function Timer(callback, delay) {
  var timerId;
  var startTime = delay;
  var remainingTime = delay;

  this.clear = function () {
    clearTimeout(timerId);
  };

  this.pause = function () {
    clearTimeout(timerId);
    remainingTime -= Date.now() - startTime;
  };

  this.resume = function () {
    startTime = Date.now();
    clearTimeout(timerId);
    timerId = setTimeout(callback, remainingTime);
  };

  this.resume();
}

var Notify = /*#__PURE__*/function () {
  function Notify() {
    var _this = this;

    Object.defineProperty(this, _toasts, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _config, {
      writable: true,
      value: {
        autoDismiss: DEFAULTS.autoDismiss,
        timeOut: DEFAULTS.timeOut,
        single: DEFAULTS.single,
        pauseOnHover: DEFAULTS.pauseOnHover,
        showProgress: DEFAULTS.showProgress
      }
    });
    Object.defineProperty(this, _onStoreChange, {
      writable: true,
      value: function value() {}
    });
    Object.defineProperty(this, _createToast, {
      writable: true,
      value: function value(type, content, options) {
        var title = options.title,
            _options$autoDismiss = options.autoDismiss,
            autoDismiss = _options$autoDismiss === void 0 ? _classPrivateFieldLooseBase(_this, _config)[_config].autoDismiss : _options$autoDismiss,
            _options$timeOut = options.timeOut,
            timeOut = _options$timeOut === void 0 ? _classPrivateFieldLooseBase(_this, _config)[_config].timeOut : _options$timeOut,
            _options$pauseOnHover = options.pauseOnHover,
            pauseOnHover = _options$pauseOnHover === void 0 ? _classPrivateFieldLooseBase(_this, _config)[_config].pauseOnHover : _options$pauseOnHover,
            _options$showProgress = options.showProgress,
            showProgress = _options$showProgress === void 0 ? _classPrivateFieldLooseBase(_this, _config)[_config].showProgress : _options$showProgress;
        return {
          id: generateUID(),
          type: type,
          content: content,
          title: title,
          autoDismiss: autoDismiss,
          timeOut: timeOut,
          pauseOnHover: pauseOnHover,
          showProgress: showProgress
        };
      }
    });
    Object.defineProperty(this, _addToast, {
      writable: true,
      value: function value(toast) {
        if (_classPrivateFieldLooseBase(_this, _config)[_config].single) {
          _classPrivateFieldLooseBase(_this, _toasts)[_toasts].length = 0; // Clears the toasts array

          _classPrivateFieldLooseBase(_this, _toasts)[_toasts].push(toast);
        } else {
          _classPrivateFieldLooseBase(_this, _toasts)[_toasts].unshift(toast);
        }

        _classPrivateFieldLooseBase(_this, _onStoreChange)[_onStoreChange](_classPrivateFieldLooseBase(_this, _toasts)[_toasts]);
      }
    });

    this.success = function (content, options) {
      if (options === void 0) {
        options = {};
      }

      var toast = _classPrivateFieldLooseBase(_this, _createToast)[_createToast](MSG_TYPE.SUCCESS, content, options);

      _classPrivateFieldLooseBase(_this, _addToast)[_addToast](toast);
    };

    this.info = function (content, options) {
      if (options === void 0) {
        options = {};
      }

      var toast = _classPrivateFieldLooseBase(_this, _createToast)[_createToast](MSG_TYPE.INFO, content, options);

      _classPrivateFieldLooseBase(_this, _addToast)[_addToast](toast);
    };

    this.warning = function (content, options) {
      if (options === void 0) {
        options = {};
      }

      var toast = _classPrivateFieldLooseBase(_this, _createToast)[_createToast](MSG_TYPE.WARNING, content, options);

      _classPrivateFieldLooseBase(_this, _addToast)[_addToast](toast);
    };

    this.error = function (content, options) {
      if (options === void 0) {
        options = {};
      }

      var toast = _classPrivateFieldLooseBase(_this, _createToast)[_createToast](MSG_TYPE.ERROR, content, options);

      _classPrivateFieldLooseBase(_this, _addToast)[_addToast](toast);
    };

    this.dismiss = function (id) {
      if (!id) return; // No ID no dismiss

      _classPrivateFieldLooseBase(_this, _toasts)[_toasts] = _classPrivateFieldLooseBase(_this, _toasts)[_toasts].filter(function (item) {
        return item.id !== id;
      });

      _classPrivateFieldLooseBase(_this, _onStoreChange)[_onStoreChange](_classPrivateFieldLooseBase(_this, _toasts)[_toasts]);
    };

    this.closeAll = function () {
      // Removes all notifications
      _classPrivateFieldLooseBase(_this, _toasts)[_toasts].length = 0;

      _classPrivateFieldLooseBase(_this, _onStoreChange)[_onStoreChange](_classPrivateFieldLooseBase(_this, _toasts)[_toasts]);
    };
  }

  var _proto = Notify.prototype;

  _proto.configure = function configure(_ref) {
    var autoDismiss = _ref.autoDismiss,
        timeOut = _ref.timeOut,
        single = _ref.single,
        pauseOnHover = _ref.pauseOnHover,
        showProgress = _ref.showProgress;
    _classPrivateFieldLooseBase(this, _config)[_config] = _objectSpread(_objectSpread({}, _classPrivateFieldLooseBase(this, _config)[_config]), {}, {
      autoDismiss: autoDismiss,
      timeOut: timeOut,
      single: single,
      pauseOnHover: pauseOnHover,
      showProgress: showProgress
    });
  };

  _proto.register = function register(_ref2) {
    var handleStoreChange = _ref2.handleStoreChange;
    _classPrivateFieldLooseBase(this, _onStoreChange)[_onStoreChange] = handleStoreChange;
  };

  return Notify;
}();

var _toasts = _classPrivateFieldLooseKey("toasts");

var _config = _classPrivateFieldLooseKey("config");

var _onStoreChange = _classPrivateFieldLooseKey("onStoreChange");

var _createToast = _classPrivateFieldLooseKey("createToast");

var _addToast = _classPrivateFieldLooseKey("addToast");

var notify = new Notify();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("path", {
  d: "M8 16c-.5 0-1.1-.1-1.6-.2s-1-.3-1.5-.5-.9-.4-1.4-.7c-.4-.3-.8-.6-1.2-1-.4-.4-.7-.8-1-1.2C1 12 .8 11.5.6 11c-.2-.5-.4-1-.5-1.5 0-.4-.1-1-.1-1.5s.1-1.1.2-1.6.3-1 .5-1.5c.1-.5.4-.9.7-1.4.3-.4.6-.8 1-1.2.4-.4.8-.7 1.2-1 .4-.2.8-.5 1.3-.7.5-.2 1-.4 1.5-.5C6.9.1 7.5 0 8 0s1.1.1 1.6.2 1 .3 1.5.5.9.4 1.4.7c.4.3.8.6 1.2 1 .4.4.7.8 1 1.2.3.4.5.9.7 1.4.2.5.4 1 .5 1.5 0 .4.1 1 .1 1.5s-.1 1.1-.2 1.6-.3 1-.5 1.5-.4.9-.7 1.4c-.3.4-.6.8-1 1.2-.4.4-.8.7-1.2 1-.4.3-.9.5-1.4.7-.5.2-1 .4-1.5.5-.4 0-1 .1-1.5.1zM8 1.3a6.7 6.7 0 100 13.4A6.7 6.7 0 008 1.3zm4.7 3.9l-.7-.7c-.1-.1-.2-.1-.2 0L6.4 9.8 4.3 7.7c-.1-.1-.2-.1-.3 0l-.7.6c-.1.1-.1.2 0 .2l2.3 2.3.7.7c.1.1.2.1.2 0l6.1-6.1c.1-.1.1-.2.1-.2z"
});

function SvgChecked(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("path", {
  d: "M8 16c-.5 0-1.1-.1-1.6-.2s-1-.3-1.5-.5-.9-.4-1.4-.7c-.4-.3-.8-.6-1.2-1-.4-.4-.7-.8-1-1.2C1 12 .8 11.5.6 11c-.2-.5-.4-1-.5-1.5 0-.4-.1-1-.1-1.5s.1-1.1.2-1.6.3-1 .5-1.5c.1-.5.4-.9.7-1.4.3-.4.6-.8 1-1.2.4-.4.8-.7 1.2-1 .4-.2.8-.5 1.3-.7.5-.2 1-.4 1.5-.5C6.9.1 7.5 0 8 0s1.1.1 1.6.2 1 .3 1.5.5.9.4 1.4.7c.4.3.8.6 1.2 1 .4.4.7.8 1 1.2.3.4.5.9.7 1.4.2.5.4 1 .5 1.5 0 .4.1 1 .1 1.5s-.1 1.1-.2 1.6-.3 1-.5 1.5-.4.9-.7 1.4c-.3.4-.6.8-1 1.2-.4.4-.8.7-1.2 1-.4.3-.9.5-1.4.7-.5.2-1 .4-1.5.5-.4 0-1 .1-1.5.1zM8 1.3a6.7 6.7 0 100 13.4A6.7 6.7 0 008 1.3zm.6 11V6.2c0-.1-.1-.1-.1-.1h-1c-.1 0-.1.1-.1.1v6.1c0 .1.1.1.1.1h1c.1.1.1 0 .1-.1zm0-7.7v-1c0-.1-.1-.1-.1-.1h-1c-.1 0-.1.1-.1.1v1c0 .1.1.1.1.1h1c.1.1.1 0 .1-.1z"
});

function SvgInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    viewBox: "0 0 16 16"
  }, props), _ref$1);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("path", {
  d: "M8 16c-.5 0-1.1-.1-1.6-.2s-1-.3-1.5-.5-.9-.4-1.4-.7c-.4-.3-.8-.6-1.2-1-.4-.4-.7-.8-1-1.2C1 12 .8 11.5.6 11c-.2-.5-.4-1-.5-1.5 0-.4-.1-1-.1-1.5s.1-1.1.2-1.6.3-1 .5-1.5c.1-.5.4-.9.7-1.4.3-.4.6-.8 1-1.2.4-.4.8-.7 1.2-1 .4-.2.8-.5 1.3-.7.5-.2 1-.4 1.5-.5C6.9.1 7.5 0 8 0s1.1.1 1.6.2 1 .3 1.5.5.9.4 1.4.7c.4.3.8.6 1.2 1 .4.4.7.8 1 1.2.3.4.5.9.7 1.4.2.5.4 1 .5 1.5 0 .4.1 1 .1 1.5s-.1 1.1-.2 1.6-.3 1-.5 1.5-.4.9-.7 1.4c-.3.4-.6.8-1 1.2-.4.4-.8.7-1.2 1-.4.3-.9.5-1.4.7-.5.2-1 .4-1.5.5-.4 0-1 .1-1.5.1zM8 1.3a6.7 6.7 0 100 13.4A6.7 6.7 0 008 1.3zm.6 8.5V3.7c0-.1-.1-.1-.1-.1h-1c-.1 0-.1.1-.1.1v6.1c0 .1.1.1.1.1h1c.1 0 .1 0 .1-.1zm0 2.5v-1c0-.1-.1-.1-.1-.1h-1c-.1 0-.1.1-.1.1v1c0 .1.1.1.1.1h1c.1.1.1 0 .1-.1z"
});

function SvgWarning(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    viewBox: "0 0 16 16"
  }, props), _ref$2);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("path", {
  d: "M8 16c-.5 0-1.1-.1-1.6-.2s-1-.3-1.5-.5-.9-.4-1.4-.7c-.4-.3-.8-.6-1.2-1-.4-.4-.7-.8-1-1.2C1 12 .8 11.5.6 11c-.2-.5-.4-1-.5-1.5 0-.4-.1-1-.1-1.5s.1-1.1.2-1.6.3-1 .5-1.5c.1-.5.4-.9.7-1.4.3-.4.6-.8 1-1.2.4-.4.8-.7 1.2-1 .4-.2.8-.5 1.3-.7.5-.2 1-.4 1.5-.5C6.9.1 7.5 0 8 0s1.1.1 1.6.2 1 .3 1.5.5.9.4 1.4.7c.4.3.8.6 1.2 1 .4.4.7.8 1 1.2.3.4.5.9.7 1.4.2.5.4 1 .5 1.5 0 .4.1 1 .1 1.5s-.1 1.1-.2 1.6-.3 1-.5 1.5-.4.9-.7 1.4c-.3.4-.6.8-1 1.2-.4.4-.8.7-1.2 1-.4.3-.9.5-1.4.7-.5.2-1 .4-1.5.5-.4 0-1 .1-1.5.1zM8 1.3a6.7 6.7 0 100 13.4A6.7 6.7 0 008 1.3zm3.5 9.3L8.9 8l2.6-2.6c.1-.1.1-.2 0-.2l-.7-.7c-.1-.1-.2-.1-.2 0L8 7.1 5.4 4.5c-.1-.1-.2-.1-.2 0l-.7.7c-.1.1-.1.2 0 .2L7.1 8l-2.6 2.6c-.1.1-.1.2 0 .2l.7.7c.1.1.2.1.2 0L8 8.9l2.6 2.6c.1.1.2.1.2 0l.7-.7c.1 0 .1-.1 0-.2z"
});

function SvgCancel(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    viewBox: "0 0 16 16"
  }, props), _ref$3);
}

var iconsMap = {
  success: /*#__PURE__*/React__default.createElement(SvgChecked, null),
  info: /*#__PURE__*/React__default.createElement(SvgInfo, null),
  warning: /*#__PURE__*/React__default.createElement(SvgWarning, null),
  error: /*#__PURE__*/React__default.createElement(SvgCancel, null)
};

function Toast(_ref) {
  var id = _ref.id,
      content = _ref.content,
      title = _ref.title,
      type = _ref.type,
      autoDismiss = _ref.autoDismiss,
      timeOut = _ref.timeOut,
      onDismiss = _ref.onDismiss,
      icons = _ref.icons,
      pauseOnHover = _ref.pauseOnHover,
      showProgress = _ref.showProgress;
  var timer = useRef();

  var _useState = useState(autoDismiss),
      isRunning = _useState[0],
      setIsRunning = _useState[1];

  var cls = "ReactNoti__Toast ReactNoti__Toast--" + type;
  var contentCls = ("ReactNoti__Toast__body " + (!icons ? 'no-icon' : '')).trim();
  var typeIconCls = "RN-icon icon-" + type;
  var progressCls = "ReactNoti__Toast__progress ReactNoti__Toast__progress--" + type;

  var handleDismiss = function handleDismiss() {
    onDismiss(id);
  };

  var startTimer = function startTimer() {
    if (!autoDismiss || timeOut <= 0) return;
    timer.current = new Timer(handleDismiss, timeOut);
    setIsRunning(true);
  };

  var clearTimer = function clearTimer() {
    if (timer.current) timer.current.clear();
  };

  useEffect(function () {
    startTimer();
    return function () {
      clearTimer();
    };
  }, []);

  var onMouseEnter = function onMouseEnter() {
    if (!pauseOnHover || !timer.current) return;
    timer.current.pause();
    setIsRunning(false);
  };

  var onMouseLeave = function onMouseLeave() {
    if (!pauseOnHover || !timer.current) return;
    timer.current.resume();
    setIsRunning(true);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: cls,
    "data-testid": "ReactNoti-Toast",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, icons && /*#__PURE__*/React__default.createElement("div", {
    className: "ReactNoti__Toast__type",
    role: "img",
    "aria-label": "alert " + type
  }, /*#__PURE__*/React__default.createElement("span", {
    className: typeIconCls
  }, iconsMap[type])), /*#__PURE__*/React__default.createElement("div", {
    className: contentCls
  }, title && /*#__PURE__*/React__default.createElement("strong", {
    className: "ReactNoti__Toast__title"
  }, title), /*#__PURE__*/React__default.createElement("section", {
    className: "ReactNoti__Toast__content"
  }, content)), /*#__PURE__*/React__default.createElement("button", {
    className: "ReactNoti__Toast__btn-dismiss",
    type: "button",
    onClick: handleDismiss,
    "data-testid": "btn-dismiss"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "RN-icon icon-close"
  })), autoDismiss && showProgress === true && /*#__PURE__*/React__default.createElement("div", {
    className: progressCls,
    "data-testid": "ReactNoti-Toast-progress",
    style: {
      animation: "rnShrinkWidth " + timeOut + "ms linear",
      animationPlayState: isRunning ? 'running' : 'paused'
    }
  }));
}

Toast.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]).isRequired,
  title: PropTypes.string,
  type: PropTypes.string.isRequired,
  autoDismiss: PropTypes.bool.isRequired,
  timeOut: PropTypes.number.isRequired,
  icons: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  pauseOnHover: PropTypes.bool.isRequired,
  showProgress: PropTypes.bool.isRequired
} : {};

function ReactNoti(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? DEFAULTS.position : _ref$position,
      _ref$autoDismiss = _ref.autoDismiss,
      autoDismiss = _ref$autoDismiss === void 0 ? DEFAULTS.autoDismiss : _ref$autoDismiss,
      _ref$timeOut = _ref.timeOut,
      timeOut = _ref$timeOut === void 0 ? DEFAULTS.timeOut : _ref$timeOut,
      _ref$single = _ref.single,
      single = _ref$single === void 0 ? DEFAULTS.single : _ref$single,
      _ref$icons = _ref.icons,
      icons = _ref$icons === void 0 ? DEFAULTS.icons : _ref$icons,
      _ref$pauseOnHover = _ref.pauseOnHover,
      pauseOnHover = _ref$pauseOnHover === void 0 ? DEFAULTS.pauseOnHover : _ref$pauseOnHover,
      _ref$showProgress = _ref.showProgress,
      showProgress = _ref$showProgress === void 0 ? DEFAULTS.showProgress : _ref$showProgress,
      className = _ref.className;

  var _useState = useState([]),
      toasts = _useState[0],
      setToasts = _useState[1];

  var cls = ("ReactNoti " + (className || '')).trim();
  var trayCls = "ReactNoti__Tray ReactNoti__Tray--" + position;

  var handleStoreChange = function handleStoreChange(newToasts) {
    var _position$split = position.split('-'),
        pos = _position$split[0];

    var nextToasts = pos === 'bottom' ? [].concat(newToasts).reverse() : [].concat(newToasts);
    setToasts(nextToasts);
  };

  notify.configure({
    autoDismiss: autoDismiss,
    timeOut: timeOut,
    single: single,
    pauseOnHover: pauseOnHover,
    showProgress: showProgress
  });
  useEffect(function () {
    notify.register({
      handleStoreChange: handleStoreChange
    });
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cls
  }, toasts.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: trayCls
  }, toasts.map(function (t) {
    return /*#__PURE__*/React__default.createElement(Toast, {
      key: t.id,
      id: t.id,
      content: t.content,
      title: t.title,
      type: t.type,
      autoDismiss: t.autoDismiss,
      timeOut: t.timeOut,
      icons: icons,
      pauseOnHover: t.pauseOnHover,
      showProgress: showProgress,
      onDismiss: notify.dismiss
    });
  })));
}

ReactNoti.propTypes = process.env.NODE_ENV !== "production" ? {
  position: PropTypes.oneOf(Object.values(POSITION)),
  autoDismiss: PropTypes.bool,
  timeOut: PropTypes.number,
  single: PropTypes.bool,
  icons: PropTypes.bool,
  pauseOnHover: PropTypes.bool,
  showProgress: PropTypes.bool,
  className: PropTypes.string
} : {};

export default ReactNoti;
export { POSITION, notify };
